import { createAction, props } from '@ngrx/store';

import { SoilAnalysis, ManualSoilAnalysis } from '../models/soil-analysis.model';

export const getSoilAnalyses = createAction('[Soil analysis] Get soil analyses');

export const setSoilAnalysisLoading = createAction(
  '[Soil analysis] Set soil analysis loading',
  props<{ loading: boolean }>(),
);

export const soilAnalysisLoadingComplete = createAction(
  '[Soil analysis] Soil analysis loading complete',
);

export const editManualSoilAnalysis = createAction(
  '[Soil analysis] Edit manual soil analysis',
  props<{ manualSoilAnalysis: ManualSoilAnalysis }>(),
);

export const initEditManualSoilAnalysis = createAction(
  '[Soil analysis] Init edit manual soil analysis',
  props<{ id: number }>(),
);

export const upsertManualSoilAnalysis = createAction(
  '[Soil analysis] Upsert manual soil analysis',
  props<{ manualSoilAnalysis: ManualSoilAnalysis }>(),
);

export const soilAnalysisUpserted = createAction(
  '[Soil analysis] Soil analysis upserted',
  props<{ id: number }>(),
);

export const showSoilAnalysisLayer = createAction(
  '[Soil analysis] Show soil analysis layer',
  props<{ showSoilAnalysisLayer: boolean }>(),
);

export const setSoilAnalyses = createAction(
  '[Soil analysis] Set soil analyses',
  props<{ soilAnalyses: SoilAnalysis[] }>(),
);

export const selectSoilAnalysis = createAction(
  '[Soil analysis] Select soil analysis',
  props<{ soilAnalysis: SoilAnalysis }>(),
);

export const showSoilAnalysis = createAction(
  '[Soil analysis] Show soil analysis',
  props<{ soilAnalysis: SoilAnalysis }>(),
);

export const selectSoilAnalysisFeature = createAction(
  '[Soil analysis] Select soil analysis feature',
  props<{ featureId: string }>(),
);

export const deselectSoilAnalysisFeature = createAction(
  '[Soil analysis] Deselect soil analysis feature',
  props<{ featureId: string }>(),
);

export const selectMultipleSoilAnalysisFeatures = createAction(
  '[Soil analysis] Select multiple soil analysis features',
  props<{ featureIds: string[] }>(),
);

export const deselectAllSoilAnalysisFeatures = createAction(
  '[Soil analysis] Deselect all soil analysis features',
);

export const linkCropField = createAction(
  '[Soil analysis] Link crop field',
  props<{ soilAnalysisId: number }>(),
);

export const openSoilAnalysesReport = createAction(
  '[Soil analysis] Open Report',
  props<{ cropFieldIds: number[]; characteristicIds?: number[] }>(),
);

export const fetchDefaultSoilAnalyses = createAction('[Soil analysis] Fetch default soil analyses');

export const setDefaultSoilAnalyses = createAction(
  '[Soil analysis] Set default soil analyses',
  props<{ soilAnalyses: SoilAnalysis[] }>(),
);
